import { defineMessages } from 'react-intl'

export const commonMessages = defineMessages({
  dateOfBirth: {
    defaultMessage: 'Date of birth',
  },
  email: {
    defaultMessage: 'E-mail Address',
  },
  fileTooLarge: {
    defaultMessage: 'File is too large to upload. Please select a smaller file.',
  },
  fileUploadFailed: {
    defaultMessage: 'Upload failed. Please try again.',
  },
  firstName: {
    defaultMessage: 'First Name',
  },
  gender: {
    defaultMessage: 'Gender',
  },
  homeTitle: {
    defaultMessage: 'Dashboard',
  },
  internalServerError: {
    defaultMessage: 'Dolpheen has some issues on servers. Please contact support.',
  },
  lastName: {
    defaultMessage: 'Last Name',
  },
  name: {
    defaultMessage: 'Name',
  },
  noConnectionToServerError: {
    defaultMessage: 'Cannot connect to server. Please check your connection or contact support.',
  },
  role: {
    defaultMessage: 'Role',
  },
  savedChanges: {
    defaultMessage: 'Saved changes',
  },
  sessionExpired: {
    defaultMessage: 'Your session has expired. Please log in again to continue.',
  },
  somethingWentWrong: {
    defaultMessage: 'Dolpheen ran into an unexpected problem',
  },
  webTitle: {
    defaultMessage: 'Dolpheen CRM',
  },
})
